module.exports = __webpack_public_path__ + "img/ic-parqueverde.780c3c73.png";